import { useCallback } from 'react';
import { usePlayerEvent } from './use-player-event';
export const useSegmentVisibilityChanged = (player, onChange) => {
  const handleSubdivisionVisibilityChanged = useCallback(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  event => {
    if (onChange) {
      const subdivisionsVisible = event?.data?.hasSubdivisions;
      const subdivisionsHeight = event?.data?.subdivisionsViewHeight;
      onChange(subdivisionsVisible, subdivisionsHeight);
    }
  }, [onChange]);
  usePlayerEvent(player, 'srgssr/subdivisionVisibilityChanged', handleSubdivisionVisibilityChanged);
};